/*
 * Copyright (c) 2026-present Amida Technology Solutions, Inc.
 * All rights reserved.
 *
 * Licensed under the Amida proprietary license.
 * See LICENSE file in the project root for license information.
 */

import { useEffect } from 'react';

import { usePreferences } from '@/api/preferences';
import { applyRail, applyTheme } from '@/stores/ui';

/**
 * Puts this person's stored theme and rail width on the document.
 *
 * Renders nothing. It exists so exactly one place writes those attributes: the
 * stylesheet reads them, and two writers would eventually disagree.
 */
export function Appearance() {
  const { prefs } = usePreferences();

  useEffect(() => {
    applyTheme(prefs.theme);
  }, [prefs.theme]);

  useEffect(() => {
    applyRail(prefs.rail);
  }, [prefs.rail]);

  return null;
}
